import WebApp from '@twa-dev/sdk'

/**
 * 텔레그램 알림창 표시
 * @param text 
 */
export const tgShowAlert = (text: string): Promise<boolean> => {
    return new Promise((resolve) => {
        try {
            if (WebApp) {
                WebApp.showAlert(text, () => {
                    resolve(true); // 사용자가 확인 버튼을 클릭한 경우 true 반환
                });
            } else {
                alert(text);
                resolve(false); // WebApp이 지원되지 않는 경우 false 반환
            }
        } catch (error) {
            alert('Does not support Telegram mini-app');
            resolve(false); // 예외 발생 시 false 반환
        }
    });
};

/**
 * 텔레그램 확인창 표시
 * @param text 
 */
export const tgShowConfirm = (text: string): Promise<boolean> => {
    return new Promise((resolve) => {
        try {
            if (WebApp) {
                WebApp.showConfirm(text, (isSuccess: boolean) => {
                    resolve(isSuccess); // 사용자가 버튼을 클릭한 후 결과를 resolve
                });
            } else {
                alert(text);
                resolve(false); // WebApp이 지원되지 않는 경우 false 반환
            }
        } catch (error) {
            alert('Does not support Telegram mini-app');
            resolve(false); // 예외 발생 시 false 반환
        }
    });
}

/**
 * 텔레그램 팝업창 표시
 * @param text 
 * @param callback 
 */
export const tgShowPopup = (text: string) => {
    try {
        if (WebApp) {
            WebApp.showPopup({ message: text })
        } else {
            alert(text)
        }
    } catch(error) {
        alert('Does not support Telegram mini-app')
    }
}